export const RETURNS_ADDRESS_ACTIVATE_DEFAULT = 'RETURNS_ADDRESS_ACTIVATE_DEFAULT'
export const RETURNS_ADDRESS_CREATE = 'RETURNS_ADDRESS_CREATE'
export const RETURNS_ADDRESS_DELETE = 'RETURNS_ADDRESS_DELETE'
export const RETURNS_ADDRESS_FETCH = 'RETURNS_ADDRESS_FETCH'
export const RETURNS_ADDRESS_UPDATE = 'RETURNS_ADDRESS_UPDATE'
export const RETURNS_ADDRESSES_FETCH_ALL = 'RETURNS_ADDRESSES_FETCH_ALL'
export const RETURNS_ADDRESSES_FETCH_ALL_LAZILY = 'RETURNS_ADDRESSES_FETCH_ALL_LAZILY'
